<template>
  <div class="gift-card-preview">
    <div class="gift-card-preview__card-design-content">
      <ImgLazy
        :image-url="cardDesignImageUrl"
        alt-text="カードデザイン"
        aspect-ratio="1"
        class="gift-card-preview__card-design-image"
      />
    </div>
    <div class="gift-card-preview__content">
      <div class="gift-card-preview__sender-name-area account">
        <div v-if="hasProfileImage" class="gift-card-preview__account-icon">
          <AccountIconWh24 :image-url="profileIconImageUrl" />
        </div>
        <div class="gift-card-preview__sender-name body-bold">
          <span
            :class="{ 'gift-card-preview__sender-name--link': profileLink }"
          >
            {{ senderName }}
          </span>
          <span class="gift-card-preview__sender-name-suffix module-text">
            さんより
          </span>
        </div>
      </div>
      <div v-if="hasMessage" class="gift-card-preview__message-block-area">
        <div class="message_block">
          <div class="message--expand">
            {{ message }}
          </div>
        </div>
      </div>
      <div class="gift-card-preview__ticket-list-area">
        <div class="gift-card-preview__gift-outline body-bold">
          ギフトが届いています
        </div>
        <div
          v-for="(itemSkuContent, itemSkuIndex) in itemSkuContents"
          :key="itemSkuIndex"
          class="gift-card-preview__item-sku-ticket-area"
        >
          <div
            v-for="index in itemSkuContent.quantity"
            :key="index"
            class="gift-card-preview__ticket-area"
          >
            <Ticket
              :image-url="itemSkuContent.imageUrl"
              :item-name="itemSkuContent.itemName"
              :item-sku-name="
                itemSkuContent.hasMultipleItemSkus
                  ? itemSkuContent.itemSkuName
                  : ''
              "
              :brand-name="itemSkuContent.brandName"
              :expiration-date="itemSkuContent.expiredDate"
              :is-ticket-expired="false"
              :is-ticket-sold-out="false"
              :showable-giftee-asterisk="true"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Ticket from '../../atoms/tickets/Ticket.vue'
import AccountIconWh24 from '../../atoms/account_icons/AccountIconWh24.vue'
import ImgLazy from '../../atoms/images/ImgLazy.vue'
import { computed } from 'vue'

const props = defineProps({
  cardDesignImageUrl: {
    type: String,
    required: true
  },
  senderName: {
    type: String,
    required: true
  },
  profileIconImageUrl: {
    type: String,
    required: false,
    default: ''
  },
  profileLink: {
    type: Boolean,
    required: false,
    default: false
  },
  message: {
    type: String,
    required: false,
    default: ''
  },
  itemSkuContents: {
    type: Array,
    required: true
  }
})

const hasProfileImage = computed(() => props.profileIconImageUrl !== '')
const hasMessage = computed(() => props.message.trim() !== '')
</script>

<style lang="scss" scoped>
.gift-card-preview {
  background-color: $white;

  &__card-design-content {
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  &__content {
    padding: 16px 16px 24px;
  }

  &__sender-name-area {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    text-align: left;
  }

  &__account-icon {
    padding-right: 8px;
  }

  &__sender-name {
    display: flex;

    &--link {
      color: $link;
    }
  }

  &__sender-name-suffix {
    font-weight: normal;
  }

  &__message-block-area {
    margin: 8px 0 16px 0;
    text-align: left;
    white-space: pre-wrap;
  }

  &__gift-outline {
    margin: 16px 0 24px;
    padding-left: 24px;
    @include bg-settings(
      '../../../../../images/icons/gift-outline.svg',
      $white,
      20px,
      22px
    );
    text-align: left;
  }

  &__item-sku-ticket-area {
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  &__ticket-area {
    text-align: left;

    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }
}
</style>
